import { TableCell } from "@mui/material";
import { IGroupTableReport } from "../../../Interfaces/optionDomain";
import { IAdditional } from "../../TableTemplate/tableTemplate";
import Button from "../../../Components/Button";
import { Edit } from "@mui/icons-material";
import {
  setAddEditOptionDomainGroupFormValues,
  setIsOptionDomainAddEditGroupOpen,
  setOptionDomainGroupEditFlag,
  setOptionDomainGroupTableFlag,
} from "../../../Features/OptionDomain/optionDomainSlice";
import { useAppDispatch } from "../../../App/hooks";
import DeleteIcon from "@mui/icons-material/Delete";
import Loading from "../../../Components/Loading/Loading";
import { useState } from "react";
import { deleteGroup } from "../../../Requests/optionDomain";
import { toast } from "react-toastify";
import { packetErrorHandler } from "../../../Utils/requestUtils";

const AdditionalHeader: React.FC = ({}) => {
  return (
    <>
      <TableCell />
      <TableCell />
    </>
  );
};

const AdditionalCol: React.FC<{
  row: IGroupTableReport;
  onAction: () => void;
}> = ({ row, onAction }) => {
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(false);

  const editHandler = () => {
    dispatch(setIsOptionDomainAddEditGroupOpen(true));
    dispatch(setOptionDomainGroupEditFlag(true));
    dispatch(setAddEditOptionDomainGroupFormValues(row));
  };

  const deleteHandler = () => {
    setLoading(true);
    deleteGroup(row.id)
      .then((resp) => {
        if (resp.data) {
          toast.success(resp.msg);
          onAction();
          dispatch(setOptionDomainGroupTableFlag(true));
        } else toast.error(resp.msg);
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  };

  return (
    <>
      <TableCell className="!w-12">
        <Button
          text={<Edit />}
          variant="contained"
          onClick={editHandler}
          className="table-btn"
        />
      </TableCell>
      <TableCell className="!w-12">
        <Button
          text={
            loading ? (
              <Loading size={16} className="!text-white" />
            ) : (
              <DeleteIcon />
            )
          }
          variant="contained"
          onClick={deleteHandler}
          className="table-btn"
        />
      </TableCell>
    </>
  );
};

export const Additional: IAdditional<IGroupTableReport> = {
  getHeader: AdditionalHeader,
  getRow: AdditionalCol,
};
